'use client';

import Link from 'next/link';
import { useEffect, useState } from 'react';
import Form from './Form/Form';
import useModal from '@/hooks/useModal';
import styles from './UnsubscribeContent.module.scss';

const UnsubscribeContent = () => {
  const [success, setSuccess] = useState(false);

  const { closeModal } = useModal();

  useEffect(() => {
    let timeout: NodeJS.Timeout;

    if (success) {
      timeout = setTimeout(() => {
        setSuccess(false);
        closeModal();
      }, 5000);
    }

    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success]);

  return (
    <div
      className={`${styles.wrapper} ${success ? styles.successWrapper : ''}`}
    >
      {success ? (
        <>
          <div className={styles.title}>Thanks!</div>
          <p className={styles.subtitle}>You&apos;ve been unsubscribed.</p>
          <button type="button" className={styles.button} onClick={closeModal}>
            <div className={styles.button_text_wrapper}>
              <span>Confirm my selection</span>
              <span>Confirm my selection</span>
            </div>
          </button>
        </>
      ) : (
        <>
          <div className={styles.title}>We&apos;re sorry to see you go!</div>
          <p className={styles.subtitle}>
            Please provide the exact name, phone number, and email address used
            for your submission in order to opt-out of information sharing.
          </p>
          <p className={styles.subtitle}>
            See{' '}
            <Link
              className={styles.link}
              aria-label="privacy policy"
              href="privacy/online-privacy-policy"
              target="_blank"
            >
              Privacy Policy
            </Link>
          </p>
          <Form setSuccess={setSuccess} />
        </>
      )}
    </div>
  );
};

export default UnsubscribeContent;
